import React, { useState} from "react";
import { Card, CardBody, Col, Container, Row, CardText, Label } from "reactstrap";
 import AuthService from "services/Admin/AuthService";
import imgLogo from "assets/images/logo.svg"
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import ErrorMessage from 'components/Common/ErrorMessage/ErrorMessage';
import { yupResolver } from "@hookform/resolvers/yup";
import { resetPassword } from "FormValidations/Admin/Auth/ResetPassword";
import PropTypes from 'prop-types';
import { API_BASE_URL_ENV } from "helpers/common";
import { useTranslation } from 'react-i18next';

const apiResetPasswordEndpoint =
  API_BASE_URL_ENV() + "/client/user/reset-password";

const ResetPassword = ({history}) => {
  const form = useForm(
    { resolver: yupResolver(resetPassword) }
  );
  const { register, watch,formState: { errors }, handleSubmit } = form
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { t } = useTranslation();

  const handleValidSubmit = async (values) => {
    setIsSubmitting(true);
    let requestData = {
      code: watch("code"),
      password: values.password,
      password_confirmation:values.confirm_password,
    };
    try {
      const res = await AuthService.resetPassword(apiResetPasswordEndpoint,requestData)
      if (res && res.status) {
        toast.success("Password reset successffuly")
        setIsSubmitting(false);
        history.push(`/login`);
      }
    } catch (error) {
      toast.error(error?.response?.data?.error)
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <div className="bgGray height100">
        <Container>
          <Row className="justify-content-center">
            <Col md="6" lg="6">
              <Card className="overflow-hidden mt-lg-5 mt-3">
                <CardBody>
                  <div className="pt-1 p-2">
                    <img src={imgLogo} className="img-fluid mx-auto d-block" alt="" />
                    <CardText tag="h5" className="text-primary mt-4 mb-1">{t("Reset Password")}</CardText>
                    <form onSubmit={handleSubmit(handleValidSubmit)}>
                      <div className="mb-3 pt-2">
                        <Label>{t("Code")}</Label>
                        <input
                          {...register('code')}
                          className='form-control height-47'
                          placeholder={t("Type Code")}
                          type="number"
                        />
                        {errors?.code && <ErrorMessage message={errors?.code?.message} />}
                      </div>
                      <div className="mb-3">
                        <Label>{t("Password")}</Label>
                        <input
                          {...register('password')}
                          type='password'
                          className='form-control height-47'
                          placeholder='**********'
                        />
                        {errors?.password && <ErrorMessage message={errors?.password?.message} />}
                      </div>
                      <div className="mb-3">
                        <Label>{t("Confirm Password")}</Label>
                        <input
                          {...register('confirm_password')}
                          type='password'
                          className='form-control height-47'
                          placeholder={t('Type Password Confirmation')}
                        />
                        {errors?.confirm_password && <ErrorMessage message={errors?.confirm_password?.message} />}
                      </div>
                      <button
                        className='btn btn-primary w-100 mt-3 font-size-14 height-47'
                        disabled={isSubmitting}
                        onClick={() => {
                        }}
                        type='submit'>
                        {t("Submit")}
                      </button>
                    </form>

                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

ResetPassword.propTypes = {
  history: PropTypes.object,
};

export default ResetPassword;
